export default __webpack_public_path__ + "static/banner-diy-car-maintenance-jobs-5bf11720c5639251d8fcae5fd9fb8d31.jpg";